import React from 'react';
import clsx from 'clsx';
import Tooltip from '../Tooltip';

import useStyles, {useInputWarningTooltipStyles} from './styles';
import {InfoIcon} from "../../images";

const WarningTooltip = (props) => {
  const {
    placement = 'top',
    icon,
    iconClassName,
    ...rest
  } = props;

  return (
    <Tooltip placement={placement} {...rest}>
      <span>
        {icon || <BlueInfoIcon {...props} />}
      </span>
    </Tooltip>
  );
};

/**
 * Warning Tooltip wrapper for customized styles to be used alongside with inputs.
 * @param props
 * @constructor
 */
export function InputWarningTooltip(props) {

  const classes = useInputWarningTooltipStyles();

  return (
    <WarningTooltip {...props} icon={<span className={classes.icon} ><InfoIcon color={"rgba(0, 0, 0, 0.26)"}/></span>}/>
  )

}


export const BlueInfoIcon = (props) => {
  const {
    iconClassName
  } = props;

  const classes = useStyles(props);

  return <i className={clsx(iconClassName || classes.icon, 'far fa-info-circle')} />
};

export const PORTFOLIO_LEVEL_DATA_ONLY_INFO_TEXT = 'Nur als “Gesamtdepot” darstellbar';

export default WarningTooltip;

